// Added By Farhan Khan Khan on 24-Dec-2025
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ShimmerTable } from "react-shimmer-effects";
import solisPowerApi from "../../api/solisPowerApi";
import { useLocation } from "react-router-dom";
import Badge from "react-bootstrap/Badge";
import moment from "moment";
import { isMobile, MobileView, BrowserView } from "react-device-detect";
import jwt_decode from "jwt-decode";
import {
  formatDate,
  formatDateForCreatedDate,
  formatDateForView,
  getUserDetails,
} from "../../utils/helper";

// Added by Jaseem 11-2-2026
import { DataGrid } from "@mui/x-data-grid";
import TextField from "@mui/material/TextField";
//=====================================================

import { Link } from "react-router-dom";
import InfoPill from "../InfoPill";
import Main from "../layout/Main";
import { Helmet } from "react-helmet";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
import * as constants from "../../constants/CONSTANT";
import { ROUTES } from "../../constants/webRouting";
import PERMISSIONS from "../../constants/permissions";

const ProductList = () => {
  const userInfo = getUserDetails();
  const location = useLocation();
  const navigate = useNavigate();
  const [body, setBody] = useState([]);
  const [product, setProduct] = useState();

  //Added By Jaseem 11-02-2026
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState(rows);
  const [searchText, setSearchText] = useState("");
  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = rows.filter((row) =>
      Object.values(row).some(
        (field) =>
          field && field.toString().toLowerCase().includes(value.toLowerCase()),
      ),
    );
    setFilteredRows(filtered);
  };
  async function init() {
    const result = await solisPowerApi.fetchProducts();
    console.log("result ==>", result);
    if (result) {
      setBody(result);
      const mappedRows = result.map((item, index) => ({
        id: item.id || index, // DataGrid ke liye mandatory
        name: item.name || "-",
        createddate: item.createddate || "-",
        product_type: item.product_type || "-",
        brand_name: item.brand_name || "-",
        status: item.status || "-",

        status: item.status || "-",
      }));

      setRows(mappedRows);
      setFilteredRows(mappedRows);
    } else {
      setBody([]);
    }
  }
  useEffect(() => {
    init();
  }, []);

  const columns = [
    {
      field: "name",
      headerName: "Product Name",
      flex: 1,
      sortable: true,
      renderCell: (params) => {
        const row = params.row;
        return (
          <Link
            to={`${ROUTES.PRODUCT.LIST}/${row.id}`}
            state={row}
            style={{
              color: "#1a73e8",
              textDecoration: "none",
              fontWeight: 600,
            }}
          >
            {row.name}
          </Link>
        );
      },
    },
    {
      field: "product_type",
      headerName: "Product Type",
      flex: 1,
      sortable: true,
      renderCell: (params) => {
        const type = params.row.product_type;
        return (
          <Badge bg="info">
            {type === "material" ? "Material" : "Non Material"}
          </Badge>
        );
      },
    },
    {
      field: "brand_name",
      headerName: "Brand",
      flex: 1,
      sortable: true,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      sortable: true,
      renderCell: (params) => {
        const status = params.row.status;
        return (
          <Badge bg={status === "Active" ? "success" : "secondary"}>
            {status}
          </Badge>
        );
      },
    },
    {
      field: "createddate",
      headerName: "Created Date",
      flex: 1,
      sortable: true,
      renderCell: (params) =>
        params.row?.createddate
          ? formatDateForView(params.row.createddate)
          : "",
    },
  ];

  // ====================================== 11-02-2026 ================================================
  const createProduct = () => {
    navigate(`/products/e`);
  };

  return (
    <Main>
      <Container>
        <Row className="">
          <Col lg={12} className="">
            <Row className="align-items-end my-2">
              {/* Added By Jaseem 11-02-2026 */}
              <Col lg={2} md={4} xl={2} sm={12} className="">
                <div className="leads-header">
                  <div className="leads-actions">
                    <TextField
                      size="small"
                      placeholder="Search Product..."
                      className="custom-search-field"
                      value={searchText}
                      onChange={(e) => handleSearch(e.target.value)}
                    />
                  </div>
                </div>
              </Col>
              {/* =================================================== */}
              <Col lg={2} md={4} sm={12} className="py-1">
                <BrowserView>
                  <div className="d-flex py-1 px-2 ">
                    <InfoPill
                      left="Total"
                      right={body?.length}
                      rightClasses="bg-custom text-white border-white fw-bold"
                      leftClasses="bg-white  fw-bold "
                    />
                  </div>
                </BrowserView>
              </Col>

              <Col className="d-flex flex-col justify-content-end align-items-end">
                {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_PRODUCT].some(
                  (permission) => {
                    return userInfo?.permissions
                      .map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                    <Button
                      size="sm"
                      className="btn-create"
                      onClick={() => createProduct(true)}
                    >
                      New Product
                    </Button>
                  )}
              </Col>
            </Row>

            {/* Added By Jaseem 11-02-2026 */}
            <Row>
              <div className="leads-page">
                {/* Header */}

                {/* DataGrid */}
                <div
                  style={{
                    height: 400,
                    width: "100%",
                    marginTop: "20px",
                    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                  }}
                >
                  <DataGrid
                    rows={filteredRows}
                    columns={columns}
                    pageSize={25}
                    rowsPerPageOptions={[25]}
                    getRowHeight={() => "auto"}
                    disableRowSelectionOnClick
                    className="custom-datagrid"
                  />
                </div>
              </div>
            </Row>
            {/* ==========================End By Jaseem ============================================= */}
          </Col>
        </Row>
      </Container>
    </Main>
  );
};
export default ProductList;
